import ShieldIcon from "@lucide/svelte/icons/shield";
import LineChartIcon from "@lucide/svelte/icons/line-chart";
import BuildingIcon from "@lucide/svelte/icons/building";
import BarChart3Icon from "@lucide/svelte/icons/bar-chart-3";
import ArrowUpRightIcon from "@lucide/svelte/icons/arrow-up-right";
import UsersIcon from "@lucide/svelte/icons/users";

/** Icon registry for server-safe string references */
export const featureIcons = {
	shield: ShieldIcon,
	"line-chart": LineChartIcon,
	building: BuildingIcon,
	"bar-chart-3": BarChart3Icon,
	"arrow-up-right": ArrowUpRightIcon,
	users: UsersIcon
};

export type FeatureIconKey = keyof typeof featureIcons;

export type FeatureCard = {
	title: string;
	description: string;
	icon: string;
};

import type { SectionTheme } from "#lib/web-ui/primitives/index.js";

export type FeaturesBaseProps = {
	theme?: SectionTheme;
	id?: string;
	class?: string;
	label?: string;
	title?: string;
	subtitle?: string;
	cards?: FeatureCard[];
};

export const featuresDefaults = {
	theme: "muted" as SectionTheme,
	id: "features",
	label: "Our Approach",
	title: "How We Deliver",
	subtitle:
		"Our comprehensive approach ensures your assets are in capable hands from start to finish.",
	cards: [
		{
			title: "Market Analysis",
			icon: "line-chart",
			description:
				"We evaluate opportunities to identify those with the highest potential returns, applying rigorous selection criteria to ensure quality."
		},
		{
			title: "Property Acquisition",
			icon: "building",
			description:
				"Our team conducts thorough assessments using advanced technology to uncover any hidden issues before finalizing."
		},
		{
			title: "Risk Assessment",
			icon: "shield",
			description:
				"Every investment includes multiple exit strategies and contingency plans, allowing us to adapt to changing conditions."
		}
	]
};
